angular.module('acme.view.application.orders.modals.privateEvent.services',[
    'acme.view.application.orders.modals.privateEvent.constants',
    'acme.common.service.calendar'
])
.service('PrivateEventService', [ '$http', '$q', '$timeout', 'ApiService', 'HelpersService', 'CartService', 'CalendarService', 'PRIVATE_EVENT_EXPIRE_OPTIONS', function($http, $q, $timeout, ApiService, HelpersService, CartService, CalendarService, PRIVATE_EVENT_EXPIRE_OPTIONS) {

    var programSearch = {
        page: 1,
            pageSize: 10,
            search: "",
            sortDirection: "asc",
            sortField: "name",
            totalItems: 0,
            type: ""
    };

    return {
        getPriceLists: function() {
            return ApiService.price.lists.list(HelpersService.getPaginator());
        },

        getDiscounts: function() {
            return ApiService.discounts.list('v2', HelpersService.getPaginator());
        },

        /**
         * Get template names for the dropdown
         * @param search Optional Search string
         * @param callback
         * @returns promise
         */
        getTemplateNames: function(isPrivate, search) {
            var props = angular.copy(programSearch);
            props.search = search;
            return ApiService.program.names(isPrivate, props);
        },

        /**
         * Get event template by its id
         * Used in template list dropdown component
         * @param id
         */
        getTemplate: function(id) {
            return ApiService.program.get(id);
        },

        /**
         * Get discount of template through template and discount relationship
         * @param templateId
         */
        getEventTemplateDetail: function(templateId) {
            return ApiService.partners.templates.detail(templateId);
        },

        /**
         * Get the event template discounted price list
         * @param discountId
         * @param priceListId
         */
        getEventTemplateDiscountedPriceList: function(discountId, priceListId) {
            return ApiService.discounts.preview({discountId: discountId,priceListId: priceListId});
        },

        /**
         * Get instance of the template by its id
         * @param eventId An event Id passed to the modal on edit
         */
        getEventInstance: function(eventId) {
            var deferred = $q.defer();

            ApiService.event.detail(eventId).then(function(res) {
                var event = res.data.payload;

                // get even more info from the event template
                ApiService.program.get(event.templateId).then(function(res) {
                    var data = (res || {}).data || {},
                        template = data.payload || {};

                    event.schedules = template.schedules;

                    var priceLists = template.priceLists || [];
                    event.priceList = priceLists[0] || event.priceList;

                    deferred.resolve({event: event, template: template});

                }, function(res) {
                    console.error(res);
                });
            }, function(res) {
                console.error(res);
            });

            return deferred.promise;
        },

        /**
         * @deprecated
         *
         * @param templateId
         * @return {*}
         */
        getEventTemplatePublished: function(templateId) {
            return ApiService.program.template.published(templateId);
        },

        /**
         * @unused
         *
         * @param templateId
         * @param discountId
         * @param categoryId
         */
        updateEventTemplateRelations: function(templateId, discountId, categoryId) {
            ApiService.partners.templates.update({
                eventTemplateId: templateId,
                discountId: discountId,
                categoryId: categoryId
            }). then(function(res){
                console.info(res);
            }, function(error){
                console.error(error);
            });
        },

        /**
         * Update event with payload constructed from the model object
         *
         * @param model
         * @param event
         * @return promise
         */
        updateEventAndTemplate: function(model, event, template) {
            var deferred = $q.defer();

            event.name = model.name;
            event.description = model.description;
            event.capacity = model.capacity;
            event.emailConfirmationMessage = model.emailConfirmationMessage;
            event.ticketDetails.ticketDurationDays = model.expireDays;
            event.ticketDetails.expireFromEventDate = model.expireOption === PRIVATE_EVENT_EXPIRE_OPTIONS[0];
            event.colorCategory = model.colorCategory;

            ApiService.program.update(template, false).then(function() {
                ApiService.event.update(event).then(function() {
                    deferred.resolve();
                });
            });
            return deferred.promise;
        },

        /**
         * Add a template event to the cart
         *   1. Create a tempate and publish an event
         *   2. Get the published event by the template id
         *   3. Get the event object needed by the cart
         *   4. return the event object
         * @param template Template payload
         * @param accountId account id
         * @param accountCategoryRelation account category relation
         * @returns A promise object
         */
        addToOrderCheckout: function (template, accountId, accountCategoryRelation) {
            var deferred = $q.defer();

            if (template.id && template.scheduleId) {

                ApiService.event.createFromPrivateSchedule(template).then(function(response) {
                    var res = response;

                    if (
                      template.schedules[0].hasOwnProperty('resourceRequest') &&
                      template.schedules[0].resourceRequest instanceof Array &&
                      template.schedules[0].resourceRequest.length
                    ) {
                        // we also need to push all resource requests one by one
                        template.schedules[0].resourceRequest.reduce(function(promise, item) {
                            return promise.then(function() {
                                return ApiService.program.resources.instance.create({
                                    id: res.data.payload.id,
                                    sendEmail: true,
                                    resourceTimeFrame: item.resourceTimeFrame,
                                    eventResource: item.eventResource,
                                    notes: item.notes
                                });
                            });
                        }, $q.when(null)).then(function() {
                            ApiService.program.instances.detail(response.data.payload.id).then(function(response) {
                                var res =  {
                                    data: {
                                        payload: [response.data.payload]
                                    }
                                };
                                deferred.resolve(res);
                            }, function(res) {
                                deferred.reject(res);
                            });
                        }, function(res) {
                            deferred.reject(res);
                        });
                    } else {
                        ApiService.program.instances.detail(res.data.payload.id).then(function(response) {
                            var res =  {
                                data: {
                                    payload: [response.data.payload]
                                }
                            };
                            deferred.resolve(res);
                        }, function(res) {
                            deferred.reject(res);
                        });
                    }
                }, function(res) {
                    deferred.reject(res);
                });

            } else {

                ApiService.program.create(template, true).then(function(res) {
                    var item = res.data.payload,
                        data = [{
                            eventTemplateId: item.id,
                            categoryId: accountCategoryRelation.categoryId, discountId: template.discountId
                        }];

                    ApiService.partners.templates.update({eventTemplateId: item.id, data: data}).then(function(res) {
                        var startTime = new Date(item.startTime),
                            endTime = new Date(item.endTime),
                            data = {
                                accountId: accountId,
                                templateId: item.id
                            };

                        startTime.setHours(0);
                        startTime.setMinutes(0);
                        startTime.setSeconds(0);
                        startTime.setMilliseconds(0);

                        endTime.setHours(23);
                        endTime.setMinutes(59);
                        endTime.setSeconds(59);
                        endTime.setMilliseconds(999);

                        data.startTime = CalendarService.toISO8601(startTime);
                        data.endTime = CalendarService.toISO8601(endTime);

                        ApiService.partners.reseller.events(data).then(function (res) {
                          deferred.resolve(res);
                        }, function (res) {
                            deferred.reject(res);
                        });

                    }, function (res) {
                        deferred.reject(res);
                    });
                });
            }

            return deferred.promise;
        },

        /**
         * Add a template event to the cart
         *   1. Create a tempate and publish an event
         *   2. Get the published event by the template id
         *   3. Get the event object needed by the cart
         *   4. Add the event object to the cart
         * @param template Template payload
         * @returns A promise object
         */
        addToCart: function(template) {
            var deferred = $q.defer();

            ApiService.program.create(template, true).then(function(res) {
                ApiService.event.getEventsByTemplateId(res.data.payload.id).then(function(res){
                    var payload = res.data.payload || [{}],
                        eventId = payload[0].id;

                    if (!eventId) {
                        deferred.reject(res);
                    }
                    ApiService.event.detail(eventId).then(function(res) {
                        var event = res.data.payload;
                        CartService.events.addToCart(event).then(function(res) {
                            deferred.resolve(res);

                        }, function(res){
                            deferred.reject(res);
                        });
                    }, function(res) {
                        deferred.reject(res);
                    });

                }, function(res) {
                    deferred.reject(res);
                });
            });
            return deferred.promise;
        },

        /**
         * Get Price list prices per priceList Id and discountId
         * @param priceList
         * @param discount
         * @returns [prices]
         */
        getDiscountedPriceList: function(priceList, discount) {
            var deferred = $q.defer();

            if ((discount || {}).id && (priceList || {}).id) {
                ApiService.discounts.preview({
                    discountId: discount.id,
                    priceListId: priceList.id
                }).then(function(res){
                    deferred.resolve(res.data.payload.prices);
                }, function(err){
                    deferred.resolve();
                });
            } else {
                return $q.when(null);
            }
            return deferred.promise;
        }
    };
}]);
